import axios from "axios";
import { IChangePassword, TAppointment, TUser } from "../interface";
import axiosJWT from "./axiosJwt";

// Lokal: in .env.local  NEXT_PUBLIC_API_URL=http://localhost:7004
export const SERVER_URL =
  process.env.NEXT_PUBLIC_API_URL || "https://car-db.aundoautoservice.de";

export const userRegister = (user: TUser): Promise<any> => {
  const url = `${SERVER_URL}/user/register`;
  return axios.post(url, user);
};

export const userLogin = (user: TUser) => {
  const url = `${SERVER_URL}/user/login`;
  return axiosJWT.post(url, user);
};

export const userLogout = () => {
  const url = `${SERVER_URL}/user/logout`;
  return axiosJWT.delete(url);
};

export const refreshToken = () => {
  const url = `${SERVER_URL}/user/refreshToken`;
  return axios.get(url);
};

export const checkAccessToken = () => {
  const url = `${SERVER_URL}/user/check-token`;
  const token = localStorage.getItem("accessToken"); // Token aus Local Storage holen

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`, // Token im Header mitsenden
    },
  });
};

export const profilePhotoUpload = (data: File) => {
  const url = `${SERVER_URL}/user/profile/photo`;
  const formData = new FormData();
  formData.append("userImage", data);

  return axiosJWT.put(url, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const changePasswordWithEmail = (passwordData: IChangePassword) => {
  const url = `${SERVER_URL}/user/changePasswordWithEmail`;
  return axios.put(url, passwordData);
};

export const deleteAccount = (confirmDelete: boolean) => {
  const url = `${SERVER_URL}/user/deleteAccount`;
  return axiosJWT.delete(url, {
    data: { confirmDelete }, // Sende die Bestätigung mit
  });
};

export const requestPasswordReset = (email: string) => {
  const url = `${SERVER_URL}/user/requestPasswordReset`;
  return axios.post(url, { email });
};

export const confirmEmailVerificationCode = (
  email: string,
  verificationCode: string,
) => {
  const url = `${SERVER_URL}/user/confirmVerificationCode`;
  return axios.post(url, { email, verificationCode });
};

// CarBuy

export const getCarBuys = () => {
  const url = `${SERVER_URL}/buy/allBuys`;
  return axios.get(url);
};

// offers

export const getOffers = () => {
  const url = `${SERVER_URL}/offer/getOffers`;
  return axios.get(url);
};

// Appointment

// Öffentlich: nur belegte Zeiten für den Kalender (keine Kundendaten)
export const getAllsAppointment = () => {
  const url = `${SERVER_URL}/appointment/availability`;
  return axios.get(url);
};

// Angemeldeter Kunde: die eigenen Termine (Anmeldung über das Cookie)
export const getMyAppointments = () => {
  const url = `${SERVER_URL}/appointment/mine`;
  return axiosJWT.get(url);
};

export const createAppointment = (appointment: TAppointment) => {
  const url = `${SERVER_URL}/appointment/create`;
  return axios.post(url, appointment);
};
